/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Количество найденных записей по типам
 * @export
 * @interface RegistrySearch200ResponseCounts
 */
export interface RegistrySearch200ResponseCounts {
  /**
   *
   * @type {number}
   * @memberof RegistrySearch200ResponseCounts
   */
  applications: number
  /**
   *
   * @type {number}
   * @memberof RegistrySearch200ResponseCounts
   */
  registry: number
}

/**
 * Check if a given object implements the RegistrySearch200ResponseCounts interface.
 */
export function instanceOfRegistrySearch200ResponseCounts(
  value: object
): value is RegistrySearch200ResponseCounts {
  if (!('applications' in value) || value['applications'] === undefined)
    return false
  if (!('registry' in value) || value['registry'] === undefined) return false
  return true
}

export function RegistrySearch200ResponseCountsFromJSON(
  json: any
): RegistrySearch200ResponseCounts {
  return RegistrySearch200ResponseCountsFromJSONTyped(json, false)
}

export function RegistrySearch200ResponseCountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistrySearch200ResponseCounts {
  if (json == null) {
    return json
  }
  return {
    applications: json['applications'],
    registry: json['registry'],
  }
}

export function RegistrySearch200ResponseCountsToJSON(
  value?: RegistrySearch200ResponseCounts | null
): any {
  if (value == null) {
    return value
  }
  return {
    applications: value['applications'],
    registry: value['registry'],
  }
}
